// extracted by mini-css-extract-plugin
export default {"photo":"return_photo__Narjb"};